import { render, staticRenderFns } from "./upLoadVideo.vue?vue&type=template&id=25a5ec0e&scoped=true&"
import script from "./upLoadVideo.vue?vue&type=script&lang=js&"
export * from "./upLoadVideo.vue?vue&type=script&lang=js&"
import style0 from "./upLoadVideo.vue?vue&type=style&index=0&id=25a5ec0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a5ec0e",
  null
  
)

export default component.exports